<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="8">
        <b-alert variant="success" :show="success">{{message}}</b-alert>
        <b-alert variant="danger"
          dismissible
          :show="failure"
          @dismissed="failure=false">
          {{message}}
        </b-alert>
        <b-form @submit.prevent="changePassword">
          <b-row>
            <b-col sm="12">
              <b-form-group label="Current password">
                <b-form-input
                  type="password"
                  v-validate="'required'"
                  v-model="currentPassword"
                  name="currentPassword"
                  :class="{'has-error': errors.has('currentPassword')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('currentPassword') }}</span>
              </b-form-group>

              <b-form-group label="New password">
                <b-form-input
                  type="password"
                  ref="password"
                  v-validate="'required|min:6|max:35'"
                  v-model="newPassword"
                  name="newPassword"
                  :class="{'has-error': errors.has('newPassword')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('newPassword') }}</span>
              </b-form-group>

              <b-form-group label="Verify password">
                <b-form-input
                  type="password"
                  v-validate="'required|confirmed:password'"
                  v-model="verifyPassword"
                  name="verifyPassword"
                  :class="{'has-error': errors.has('verifyPassword')}"
                >
                </b-form-input>
                <span class="red">{{ errors.first('verifyPassword') }}</span>
              </b-form-group>

              <b-form-group>
                <b-button type="submit" name="submit" variant="primary" :disabled="!canSubmit">Save changes</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Password',
  data: function () {
    return {
      currentPassword: '',
      newPassword: '',
      verifyPassword: '',
      success: false,
      failure: false,
      message: ''
    }
  },
  computed: {
    /**
     * A computed shorthand for the passwordsFilledIn method.
     */
    canSubmit: function () {
      return this.passwordsFilledIn()
    }
  },
  methods: {
    /**
     * Sends a put request to the backend API with the new password as well as the old password to check against in order to update account password.
     */
    changePassword: function () {
      let self = this

      self.success = false
      self.failure = false

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.put(`${process.env.VUE_APP_API_URL}api/admins/password`, {
            password: this.newPassword,
            currentPassword: this.currentPassword
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'x-access-token': localStorage.getItem('user-token')
            }
          })
            .then(function (response) {
              self.success = true
              self.message = 'Password successfully changed!'
            })
            .catch(function (error) {
              let data = error.response.data

              if (data.success === false) {
                self.failure = true
                self.message = data.message
              }
            })
        }
      }).catch(() => {
        console.log(this.errors.all())
      })
    },
    /**
     * Checks whether or not all 3 password fields are filled in, in order to toggled disabled attribute on the submit button.
     */
    passwordsFilledIn: function () {
      if (this.currentPassword !== '' && this.newPassword !== '' && this.verifyPassword !== '') {
        return true
      }

      return false
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
